import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

/** Custom tote bag icon — replaces ShoppingCart for experience marketplace feel */
export function IconTote({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      {/* Bag body — rounded trapezoid */}
      <path d="M4.5 9H19.5L18 21H6L4.5 9Z" />
      {/* Handle arcs */}
      <path d="M8 9V6C8 3.79 9.79 2 12 2C14.21 2 16 3.79 16 6V9" />
      {/* Small star/sparkle inside */}
      <circle cx="12" cy="15" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}
